import { useState, useEffect } from 'react';
import { settingsService, PublicSettings } from '../services/settings';

let cache: PublicSettings | null = null;
let cacheAt = 0;
const CACHE_TTL_MS = 60_000;
let inflight: Promise<PublicSettings | null> | null = null;

export function invalidateSettingsCache() {
    cache = null;
    cacheAt = 0;
    inflight = null;
}

/** Charge les paramètres dès le démarrage (évite flash téléphone/email statiques). */
export function prefetchPublicSettings(): Promise<PublicSettings | null> {
    const fresh = cache && Date.now() - cacheAt < CACHE_TTL_MS;
    if (fresh && cache) {
        return Promise.resolve(cache);
    }
    if (!inflight) {
        inflight = settingsService
            .getPublic()
            .then((data) => {
                cache = data;
                cacheAt = Date.now();
                return data;
            })
            .catch((): PublicSettings | null => null)
            .finally(() => {
                inflight = null;
            });
    }
    return inflight!;
}

export function useSettings() {
    const [settings, setSettings] = useState<PublicSettings | null>(cache);
    const [loading, setLoading] = useState(!cache);

    useEffect(() => {
        const fresh = cache && Date.now() - cacheAt < CACHE_TTL_MS;
        if (fresh) {
            setSettings(cache);
            setLoading(false);
            return;
        }
        prefetchPublicSettings().then((data) => {
            if (data) setSettings(data);
            setLoading(false);
        });
    }, []);

    return { settings, loading, refetch: () => {
        invalidateSettingsCache();
        return settingsService.getPublic().then(data => {
            cache = data;
            cacheAt = Date.now();
            setSettings(data);
            return data;
        });
    }};
}
